import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {setUiData} from "../../store/uiSlice";
import {useDispatch} from "react-redux";

const DocuSignCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // After processing the callback, navigate back to the main integration page

    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("code");

    if (code) {
      dispatch(setUiData({showLoader: true}));
      navigate(`/docusign-initiate?code=${code}`);
    }
  }, [navigate]);

  return <div>Processing Docusign ...</div>;
};

export default DocuSignCallback;
